module.exports = __webpack_public_path__ + "static/media/submissionBanner.be6c1fd3.png";